import React from 'react';

import { FormattedMessage, type MessageDescriptor } from 'react-intl';

/**
 * Renders a dropdown option's label, optionally in its own typeface.
 *
 * Used by the typography font pickers so each option previews in the font it
 * represents. A per-option font stack is unsafe typography by definition — the
 * whole point is to preview non-Atlassian fonts, and there is no design token
 * for "Lora" / "Noto Sans" / etc. This tiny component is the single, deliberately
 * isolated place that carries the override (and is excluded from the
 * no-unsafe-typography ratchet); the shared ConfigFieldDropdown stays
 * token-clean by delegating here. When `fontFamily` is unset the label renders
 * in the default UI font, unchanged.
 */
export const OptionLabel = ({
	fontFamily,
	label,
}: {
	fontFamily?: string;
	label: MessageDescriptor;
}): React.JSX.Element =>
	fontFamily ? (
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-primitives-text
		<span style={{ fontFamily }}>
			<FormattedMessage {...label} />
		</span>
	) : (
		<FormattedMessage {...label} />
	);
